// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"b06c5e69","422":"6df92514","455":"c2df4e3e"}[chunkId] + ".chunk.js";
};